import React from "react";

import phone from "../../images/phone.svg";
import insta from "../../images/insta.svg";
import map from "../../images/map.svg";
import close from "../../images/close.svg";
import home from "../../images/home.svg";
import contact from "../../images/contact.svg";
import chevron_up from "../../images/chevron-up.svg";
import globe from "../../images/globe.svg";
import question from "../../images/question.svg";

const iconMap = {
    phone: phone,
    insta: insta,
    map: map,
    close: close,
    home: home,
    contact: contact,
    chevronup: chevron_up,
    globe: globe,
    question: question
};

const Icons = ({ name }) => {
    return (<img alt={name} src={iconMap[name]} />)
}

export default Icons